import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;



class Category {
  create = async (category: any) => {
    const response = await axios.post<any>(`${API_URL}item-category`, category)
      .catch((e) => {
        throw e.message;
      });
    return response.data;
  };

  edit = async (category: any, code: any) => {
    await axios.put<any>(`${API_URL}item-category/${code}`, category)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}item-category/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.category;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}item-category`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.category;
  };

  search = async (keyword: any) => {
      const response = await axios.get<any>(`${API_URL}item-category-search/${keyword}`)
        .catch((e) => {
          throw e.message;
        });
      return response.data.category;
    };
}

export default new Category();
